export const SET_AUDIO_LIST = 'AUDIO:SET_AUDIO_LIST';
export const SET_LATEST_AUDIO_EVENT = 'AUDIO:SET_LATEST_AUDIO_EVENT';